<template>
  <div class="service-ecosystem">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">易隆创·服务生态</div>
        <div class="module-subtitle">结合行业特性，呈现能力在不同业务场景中的定制化解决方案</div>
      </div>
      <div class="module-body">
        <div class="service-item" v-for="(item, index) in dataList" :key="index">
          <div class="service-item-icon-box">
            <img class="service-item-icon" :src="require(`@/assets/img/service/ServiceEcosystem/icon_item_${item.id}.png`)">
          </div>
          <div class="service-item-content">
            <div class="service-item-title">{{ item.name }}</div>
            <div class="service-item-text">{{ item.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dataList: [
        { id: 'tbfw', name: '投标服务', text: '全流程统筹各类标书，协同高效应标' },
        { id: 'sjfw', name: '设计服务', text: '精准洞察需求，定制高落地性设计方案' },
        { id: 'wbfw', name: '维保服务', text: '多品类全周期运维设备/系统，护航稳定' },
        { id: 'cxcfw', name: '出现场服务', text: '快速奔赴现场，解决异地/现场办事难题' },
        { id: 'gjfw', name: '管家服务', text: '专属管家全维助力业务高效推进' },
        { id: 'xsfw', name: '销售服务', text: '代访客户，精准衔接需求与商务沟通' },
        { id: 'gclqdhsfw', name: '工程量清单核算服务', text: '精准核算工程量，细化条目，助力成本可控' },
        { id: 'twzzfw', name: '图文制作服务', text: '创意设计、专业输出精品视频与图文内容' },
      ]
    }
  }
};
</script>

<style lang="less" scoped>
.service-ecosystem {
  padding: 64px 0;
  background-color: #fff;

  .content-center {
    .module-body {
      height: 272px;
      margin-top: 32px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: space-between;

      .service-item {
        width: 293px;
        height: 120px;
        padding-left: 18px;
        display: flex;
        align-items: center;

        .service-item-icon-box {
          flex-shrink: 0;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background-color: rgba(255, 130, 1, .1);
          display: flex;
          justify-content: center;
          align-items: center;
          .service-item-icon {
            width: 32px;
            height: 32px;
          }
        }

        .service-item-content {
          margin-left: 16px;
          .service-item-title {
            font-family: @font-medium;
            font-size: 18px;
          }
          .service-item-text {
            margin-top: 10px;
            font-size: 14px;
            text-align: justify;
          }
        }
      }
    }
  }
}
</style>
